<template>
    <div class="modal view-product fade" id="viewDocumentos" tabindex="-1" aria-labelledby="viewDocumentos" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addNewDocumentosLabel">INFORMACIÓN IMPORTANTE</h5>
                    <button 
                        type="button" 
                        class="btn-close d-md-none" 
                        data-bs-dismiss="modal" 
                        aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <span class="close-modal d-none d-md-block" data-bs-dismiss="modal">
                        <i data-feather="x"></i>
                    </span>
                    <div class="row gy-4 g-md-0 justify-content-center">
                        <div class="col-12">
                            <div class=" icon-alert"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-alert-triangle alert-icon">
                                    <path
                                        d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                    </path>
                                    <line x1="12" y1="9" x2="12" y2="13"></line>
                                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                </svg></div>
                            <div class="alert alert-info alert-with-icon" role="alert">
                               
                                <div class="mt-3">
                                    <b>El titular</b> debe presentar la tarjeta de crédito/débito y documento de identificación al momento de recibir el pedido.
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="btn-box">
                        <button 
                            type="button" 
                            class="btn btn-outline rounded-pill btn-responsive" 
                            data-bs-dismiss="modal" 
                            aria-label="Close">
                            Entendido
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalPresentarDocumentos',
    mounted() {
      
        const modalEl = document.getElementById('viewDocumentos');
        if (modalEl) {
            modalEl.addEventListener('shown.bs.modal', () => {
                if (window.feather) {
                    window.feather.replace();
                }
            });
        }
    }
}
</script>

<style scoped>
.alert-with-icon {
    border-radius: 8px;
}

.alert-info {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.aviso-flex {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    justify-content: center;
}

.alert-icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
}



.modal-footer {
    justify-content: center;
    padding: 1rem;
}

.btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
}

.btn-responsive {
    min-width: 120px;
    padding: 0.5rem 1.5rem;
    font-size: 1rem;
}

 .icon-alert {
        display: flex;
        justify-content: center;
        align-items: center;
    }
@media (max-width: 576px) {
    .modal-dialog {
        margin: 0.5rem;
    }
    
    .modal-header {
        padding: 0.75rem 1rem;
    }
    
    .modal-title {
        font-size: 1rem;
    }
    
    .modal-body {
        padding: 1rem;
    }
    
    .btn-responsive {
        width: 100%;
        padding: 0.75rem 1rem;
        font-size: 0.95rem;
    }
    
    .btn-box {
        width: 100%;
    }
    
    .alert-info {
        font-size: 0.9rem;
    }
}


@media (min-width: 577px) and (max-width: 768px) {
    .btn-responsive {
        min-width: 150px;
    }
}
</style>